/**
 * Created by fijas on 5/18/17.
 */

import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

import {Contact} from '../../contacts/Contact';
import {Search} from '../../contacts/Search';
import {Observable} from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Reminder} from '../../projects/projects-detail/Reminder';
import {ContactProjectSearch} from '../../contacts/ContactProjectSearch';

@Injectable()
export class ContactService {
    readonly contactsUrl: string;  // URL to web api
    readonly reminderUrl: string;
    readonly generateUrl: string;
    readonly favoriteUrl: string;

    constructor(private http: HttpClient) {
        this.contactsUrl = environment.apiBaseUrl + 'contacts';
        this.reminderUrl = environment.apiBaseUrl + 'reminders';
        this.generateUrl = environment.apiBaseUrl + 'generates';
        this.favoriteUrl = environment.apiBaseUrl + 'favorites';
    }

    getContacts(page: string, searchModel: Search, view: string) {
        let params = new HttpParams()
            .set('page', page)
            .set('term', searchModel.term)
            .set('period', searchModel.period.toString());
        if (view != null) {
            params = params.set('view', view);
        }

        if (searchModel.countries.length > 0) {
            const countries: any[] = [];
            for (const country of searchModel.countries) {
                countries.push(country.value);
            }
            params = params.set('filter[countries]', countries.join(','));
        }
        if (searchModel.origins.length > 0) {
            const origins: any[] = [];
            for (const origin of searchModel.origins) {
                origins.push(origin.value);
            }
            params = params.set('filter[origins]', origins.join(','));
        }
        if (searchModel.classifications.length > 0) {
            const classifications: any[] = [];
            for (const classification of searchModel.classifications) {
                classifications.push(classification.value);
            }
            params = params.set('filter[classifications]', classifications.join(','));
        }
        if (searchModel.show != '') {
            params = params.set('filter[show]', searchModel.show);
        }

        return this.http.get(this.contactsUrl, {params: params, observe: 'response'});
    }

    getContact(id: number): Observable<Contact> {
        return this.http.get<Contact>(this.contactsUrl + '/' + id + '?expand=ongoing,completed,hold,projectIndustryStatistics,projectManagers,keyContacts');
    }

    getProjects(id: number, page: number, type = '0', contactProjectSearch: ContactProjectSearch) {
        let params = new HttpParams()
            .set('page', page.toString());

        if (contactProjectSearch.country) {
            params = params.set('country_id', contactProjectSearch.country.toString());
        }

        if (contactProjectSearch.industry) {
            params = params.set('industry_id', contactProjectSearch.industry.toString());
        }

        if (contactProjectSearch.status) {
            params = params.set('status', contactProjectSearch.status.toString());
        }

        if (contactProjectSearch.contactType) {
            params = params.set('contact_type', contactProjectSearch.contactType.toString());
        }

        if (contactProjectSearch.contactOffice) {
            params = params.set('contact_office', contactProjectSearch.contactOffice.toString());
        }

        return this.http.get(this.contactsUrl + '/' + id + '/projects/' + type + '?expand=project', {params: params, observe: 'response'});
    }

    getProjectFilters(id: number) {
        return this.http.get(this.contactsUrl + '/' + id + '/project-filter');
    }

    getAssociated(id: number): Observable<any> {
        return this.http.get<any>(this.contactsUrl + '/' + id + '/associated');
    }

    getContactProjectsStatistics(id: number): Observable<any> {
        return this.http.get<any>(this.contactsUrl + '/' + id + '/statistics');
    }

    getContactWinsStatistics(id: number, view: number): Observable<any> {
        return this.http.get<any>(this.contactsUrl + '/' + id + '/wins/' + view.toString());
    }

    addNewReminder(date: string, note: string, id: number) {
        return this.http.post(this.reminderUrl, {date: date, note: note, contact_id: id, type: 1});
    }

    getReminders(id: number): Observable<Reminder[]> {
        const params = new HttpParams()
            .set('type', '1')
            .set('id', id.toString());

        return this.http.get<Reminder[]>(this.reminderUrl, {params: params});
    }

    removeReminder(id: number): Observable<any> {
        return this.http.delete<any>(this.reminderUrl + '/' + id.toString() + '?type=1');
    }

    generatePDF(id: number, randomString: string) {
        return this.http.post(this.generateUrl, {type: 'pdf', 'for': 'contact', id: id, channel_hash: randomString});
    }

    sendEmail(id: number) {
        return this.http.post(this.generateUrl, {type: 'email', 'for': 'contact', id: id});
    }

    toggleFavorite(contactId: number) {
        return this.http.post(this.favoriteUrl, {id: contactId, type: 1});
    }

    exportProjects(contactId: number, randomString: string) {
        return this.http.post<any>(this.contactsUrl + '/' + contactId + '/export-projects', {channel_hash: randomString});
    }

    claimCompany(contactId: number) {
        return this.http.post<any>(this.contactsUrl + '/' + contactId + '/claim-company', {});
    }

    getConstructionSpend(contactId: number) {
        return this.http.get<any>(this.contactsUrl + '/' + contactId + '/construction-spends');
    }

    logLinkedinClicked(contactId: number, id: number, type) {
        return this.http.post(this.contactsUrl + '/save-officer-linkedin-clicked', {contactId: contactId, id: id, type: type});
    }
}
